import React, { Component } from 'react';
import { Icon } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';

import footerLogo from './../../assets/SEF-Logo-Master-CMYK.png';

import './footer.scss';

class footer extends Component {
    getYear() {
        return new Date().getFullYear();
    }
    render() {
        return (
            <div>
                <footer id='global-footer'>
                    <section id='footer-top'>
                        <div id='' className=''>
                            <h4>Powered by</h4>
                            <img src={footerLogo} alt='footer-logo' id="footer-logo"/>
                        </div>

                        <div id='' className=''>
                            <h4>Connect with us</h4>
                            <a href="https://twitter.com/weareSEFirst" target="_blank" rel="noopener noreferrer">
                                <Icon size='big' link name='twitter' inverted className="social-link"/>
                            </a>
                            <a href='https://www.linkedin.com/company/sustainable-energy-first' target="_blank" rel="noopener noreferrer">
                                <Icon size='big' link name='linkedin' inverted className="social-link" />
                            </a>
                        </div>

                        <div id='' className=''>
                            <h4>Sustainable Energy First</h4>
                            <a href="https://www.sefirst.com/" className='footer-link' target="_blank" rel="noopener noreferrer">Homepage</a>
                            <a href="https://www.sefirst.com/ecosystem/sustainability-teams/" className='footer-link' target="_blank" rel="noopener noreferrer">Services</a>
                            <a href="https://www.sefirst.com/sectors-and-industries/" className='footer-link' target="_blank" rel="noopener noreferrer">Sectors</a>
                            <a href="https://www.sefirst.com/insights/" className='footer-link' target="_blank" rel="noopener noreferrer">Insight</a>
                        </div>

                        <div id='' className=''>
                            <a href="https://www.inenco.com/wp-content/uploads/2021/11/Privacy-Policy-Nov.-2021.pdf" className='footer-link' target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                            <a href="/CookiePolicy" className='footer-link' target="_blank" rel="noopener noreferrer">Cookie Policy</a>
                        </div>
                    </section>

                    <section id="footer-bottom"> 
                            <p>&copy; {this.getYear()} Sustainable Energy First</p>
                    </section>
                </footer>
            </div>
        );

    }

}



export default footer;